import { Coordinate } from '../model/coordinate';

export type SeriesMarkerPosition = 'aboveBar' | 'belowBar' | 'inBar' | 'inBarOffset';

export type SeriesMarkerShape = 'circle' | 'square' | 'arrowUp' | 'arrowDown' | 'textMarker' | 'line';

export interface SeriesMarkerText {
	content: string;
	x: Coordinate;
	y: Coordinate;
	width: number;
	height: number;
}

export interface SeriesMarker<TimeType> {
	time: TimeType;
	position: SeriesMarkerPosition;
	shape: SeriesMarkerShape;
  	color: string;
	id?: string;
	text?: string;
	text1?: string;
	size?: number;
	textColor?:string;
  textColor1?:string;
  font?:string;
	positionOffset?:PositionOffset;
  isLast?:boolean;
  lastType?:string
}

export interface InternalSeriesMarker<TimeType> extends SeriesMarker<TimeType> {
	internalId: number;
}

export interface PositionOffset
{
	x:number;
	y:number;
  direction?:OffsetDirection;
  secondMarkerOffset?:number;
}

export enum OffsetDirection
{
	Up,
	Down
}
